var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._g(_vm._b({staticClass:"icon",class:_vm.$options.methods.getStyleClasses(_vm.props),attrs:{"viewBox":"0 0 24 24","role":"img"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('title',[_vm._v(_vm._s(_vm.props.title || _vm.props.name))]),_vm._v(" "),(_vm.props.desc)?_c('desc',[_vm._v(_vm._s(_vm.props.desc))]):_vm._e(),_vm._v(" "),_c('path',{attrs:{"d":_vm.$options.methods.getPath(_vm.props)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df8fc834","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/app-icon.vue
// module id = 757
// module chunks = 0